import { render } from "./GlobalPreloader.vue?vue&type=template&id=6e530259&scoped=true"
import script from "./GlobalPreloader.vue?vue&type=script&lang=js"
export * from "./GlobalPreloader.vue?vue&type=script&lang=js"

import "./GlobalPreloader.vue?vue&type=style&index=0&id=6e530259&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e530259"]])

export default __exports__